export default (state = {}, { type, payload = {} }) => {
  switch (type) {
    case "USER_BASIC_DETAILS":
      return {
        ...state,
        basic: { ...payload }
      };
    case "USER_EDUCATION_DETAILS":
      return {
        ...state,
        education: { ...payload }
      };
    case "USER_APPOINTMENT_DETAILS":
      return {
        ...state,
        appointment: { ...payload }
      };
    case "USER_PAYMENT_DETAILS":
      return {
        ...state,
        payment: { ...payload }
      };
    case "USER_COMPLETED_STEPS":
      return {
        ...state,
        completedSteps: { ...payload }
      };
    case "MENU_HIDE":
      return {
        ...state,
        hide:payload.hide
      };
    case "USER_APPROVE_MODAL": {
      return {
        ...state,
        isApproveModal: payload?.value ?? false,
        isRejected: Boolean(payload.status == "REJECTED")
      };

    }
    default:
      return state;
  }
};
